module.exports = __webpack_public_path__ + "img/laptop-code.1ecb367a.svg";